import { render, staticRenderFns } from "./SupplyChainProvince.vue?vue&type=template&id=427540d1&scoped=true&"
import script from "./SupplyChainProvince.vue?vue&type=script&lang=js&"
export * from "./SupplyChainProvince.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainProvince.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SupplyChainProvince.vue?vue&type=style&index=1&id=427540d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427540d1",
  null
  
)

export default component.exports